import classnames from 'classnames';
import React, { useRef } from 'react';

import { useOnClickOutside } from '../../utils/useOnClickOutside';
import { Month } from './types';

interface MonthDropdownOptionsProps {
  onChange: (month: number) => void;
  onCancel: () => void;
  currentMonthIndex: number;
  months: Month[];
}

export const MonthDropdownOptions: React.FC<MonthDropdownOptionsProps> = ({
  currentMonthIndex,
  months,
  onChange,
  onCancel,
}) => {
  const dropdownRef = useRef(null);
  useOnClickOutside(dropdownRef, () => onCancel());

  const Option = (month: Month, index: number, isSelected: boolean) => {
    const { disabled, name } = month;

    return (
      <div
        className={classnames('react-datepicker__month-option', {
          'react-datepicker__month-option--selected_month': isSelected,
          'react-datepicker__month-option--disabled': disabled,
        })}
        key={name}
        onClick={() => onChange(index)}
      >
        {isSelected && <span className="react-datepicker__month-option--selected">✓</span>}
        {name}
      </div>
    );
  };

  return (
    <div data-test-id="month-options-dropdown" className="react-datepicker__month-dropdown" ref={dropdownRef}>
      {months.map((month, index) => Option(month, index, currentMonthIndex === index))}
    </div>
  );
};
